import React, { useEffect, useState } from "react";
import { Grid, Pagination } from "@mui/material";
import ContactUsCard from "../../../components/contactUsCard/ContactUsCard";
import ContactUsCardSkeleton from "../../../components/contactUsCard/ContactUsCardSkeleton";

const AllContactUs = ({ dataLoading, allData }) => {
  const allDataLoading = [1, 2];

  const defaultStartSlice = 0;
  const defaultEndSlice = 12;

  const [startSlice, setStartSlice] = useState(defaultStartSlice);
  const [endSlice, setEndSlice] = useState(defaultEndSlice);
  const [pageCount, setPageCount] = useState(1);
  const [page, setPage] = useState(1);
  const handleChange = (event, value) => {
    setPage(value);
    setStartSlice(parseInt(value * defaultEndSlice - defaultEndSlice));
    setEndSlice(parseInt(value * defaultEndSlice));
  };

  useEffect(() => {
    if (allData) {
      const count = allData.length / defaultEndSlice;
      setPageCount(parseInt(Math.ceil(count)));
    }
  }, [allData]);

  return (
    <Grid container spacing={2}>
      {dataLoading ? (
        allDataLoading.map((item) => (
          <Grid item xs={12} sm={12} md={6} lg={6} key={item}>
            <ContactUsCardSkeleton />
          </Grid>
        ))
      ) : allData ? (
        allData
          .slice(startSlice, endSlice)
          .reverse()
          .map((item) => (
            <Grid item xs={12} sm={12} md={6} lg={6} key={item._id}>
              <ContactUsCard item={item} />
            </Grid>
          ))
      ) : (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div>
            <p>No Replied Found</p>
          </div>
        </Grid>
      )}
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <div className="pagination">
          <Pagination count={pageCount} page={page} onChange={handleChange} />
        </div>
      </Grid>
    </Grid>
  );
};

export default AllContactUs;
